import React, { Component } from "react";
import ContentListView from "./Content";
import { FileDrop } from 'react-file-drop'
import styled, { css } from "styled-components";
import { observer } from 'mobx-react'
import './common.css'
import { AddMessageToStore, CommonStore, IsChatRoomActive, LocalStorage } from "../Store";
import { toJS } from "mobx";

export default observer(class MessageList extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    messageList: [],
    onEnteringFrame: false
  };


  render() {
    const { onFileDrop } = this.props
    const isChatActive = IsChatRoomActive()
    const messageList = toJS(CommonStore.messageList)
    const pendingMessageList = toJS(CommonStore.pendingMessage)
    return (
      <FileDrop

        onDrop={(fileList, ev) => {
          ev.preventDefault()
          if (onFileDrop && isChatActive) {
            onFileDrop(fileList)
          }
          this.setState(state => ({ ...state, onEnteringFrame: false }))
        }}
        onFrameDragEnter={() => isChatActive && this.setState(state => ({ ...state, onEnteringFrame: true }))}
        onFrameDragLeave={() => isChatActive && this.setState(state => ({ ...state, onEnteringFrame: false }))}
        onDragLeave={() => isChatActive && this.setState(state => ({ ...state, onEnteringFrame: false }))}
        onFrameDrop={() => isChatActive && this.setState(state => ({ ...state, onEnteringFrame: false }))}
      >
        <FileDropOverlay
          isActive={this.state.onEnteringFrame}
        >
          <FileDropText>Drop your file here</FileDropText>
        </FileDropOverlay>
        <ContentListView messages={messageList} pendingList={pendingMessageList} />
      </FileDrop>
    )
  }
})

const FileDropOverlay = styled.div`
  height: 100%;
  width: 100%;
  display: none;
  ${props => props.isActive && css`display: block;`}
  background-color: rgba(0,0,0,0.7);
  position: absolute;
  z-index: 1000;
  color: white;
`

const FileDropText = styled.div`
  margin: 0 auto;
  margin-top: 30%;
  width: 50%;
`
